var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlphabate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1875",
    d: "M0-682.665H46.436v46.436H0Z",
    transform: "translate(0 682.665)",
    fill: "#0a64f9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1869",
    transform: "translate(936.897 430.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1873",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1879",
    transform: "translate(5.442 9.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M0,0V6.893",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1883",
    transform: "translate(5.442 30.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1885",
    d: "M0-95.683v-6.984",
    transform: "translate(0 102.666)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1887",
    transform: "translate(9.07 5.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1889",
    d: "M0,0H6.984",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1891",
    transform: "translate(1.814 1.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1893",
    d: "M-49.705,0a3.628,3.628,0,0,0-3.628,3.628,3.628,3.628,0,0,0,3.628,3.628,3.628,3.628,0,0,0,3.628-3.628A3.628,3.628,0,0,0-49.705,0Z",
    transform: "translate(53.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1895",
    transform: "translate(37.366 1.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1897",
    d: "M-49.705,0a3.628,3.628,0,0,0-3.628,3.628,3.628,3.628,0,0,0,3.628,3.628,3.628,3.628,0,0,0,3.628-3.628A3.628,3.628,0,0,0-49.705,0Z",
    transform: "translate(53.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1899",
    transform: "translate(1.814 37.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1901",
    d: "M-49.705,0a3.628,3.628,0,0,0-3.628,3.628,3.628,3.628,0,0,0,3.628,3.628,3.628,3.628,0,0,0,3.628-3.628A3.628,3.628,0,0,0-49.705,0Z",
    transform: "translate(53.333 0)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1903",
    transform: "translate(30.292 5.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1905",
    d: "M-96.926,0H-104",
    transform: "translate(104)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1907",
    transform: "translate(40.994 9.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1909",
    d: "M0,0V6.893",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1911",
    transform: "translate(37.366 37.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1913",
    d: "M-99.411-49.705a3.628,3.628,0,0,0-3.628-3.628,3.628,3.628,0,0,0-3.628,3.628,3.628,3.628,0,0,0,3.628,3.628A3.628,3.628,0,0,0-99.411-49.705Z",
    transform: "translate(106.666 53.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1915",
    transform: "translate(40.994 30.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1917",
    d: "M0-96.926V-104",
    transform: "translate(0 104)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1919",
    transform: "translate(30.474 40.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1921",
    d: "M-94.44,0h-6.893",
    transform: "translate(101.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1923",
    transform: "translate(9.07 40.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1925",
    d: "M0,0H6.984",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1927",
    transform: "translate(20.86 3.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1929",
    d: "M-31.066,0a2.267,2.267,0,0,0-2.267,2.267,2.267,2.267,0,0,0,2.267,2.267A2.267,2.267,0,0,0-28.8,2.267,2.267,2.267,0,0,0-31.066,0",
    transform: "translate(33.333)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1931",
    transform: "translate(20.86 38.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1933",
    d: "M-31.066,0a2.267,2.267,0,0,0-2.267,2.267,2.267,2.267,0,0,0,2.267,2.267A2.267,2.267,0,0,0-28.8,2.267,2.267,2.267,0,0,0-31.066,0",
    transform: "translate(33.333)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1935",
    transform: "translate(38.727 21.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1937",
    d: "M-31.066,0a2.267,2.267,0,0,0-2.267,2.267,2.267,2.267,0,0,0,2.267,2.267A2.267,2.267,0,0,0-28.8,2.267,2.267,2.267,0,0,0-31.066,0",
    transform: "translate(33.333)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1939",
    transform: "translate(3.174 21.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1941",
    d: "M-31.066,0a2.267,2.267,0,0,0-2.267,2.267,2.267,2.267,0,0,0,2.267,2.267A2.267,2.267,0,0,0-28.8,2.267,2.267,2.267,0,0,0-31.066,0",
    transform: "translate(33.333)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1943",
    transform: "translate(16.779 16.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    d: "M-176.454-183.91l-3.984-11.628a2.654,2.654,0,0,0-5.029.021l-3.866,11.607",
    transform: "translate(189.333 197.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1947",
    transform: "translate(19.227 26.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1949",
    d: "M0,0H7.709",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabate);
export default __webpack_public_path__ + "static/media/alphabate.0d0873711a013394042c20e84df412fa.svg";
export { ForwardRef as ReactComponent };